import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { subscriptionAPI } from '../services/api'

export default function PaymentCallback() {
  const [status, setStatus] = useState<'checking' | 'success' | 'failed'>('checking')
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  useEffect(() => {
    const orderId = searchParams.get('order_id')
    if (!orderId) {
      setStatus('failed')
      return
    }

    const verify = async () => {
      try {
        const res = await subscriptionAPI.verifyOrder(orderId)
        if (res.data.paid) {
          setStatus('success')
          setTimeout(() => navigate('/dashboard'), 2000)
        } else {
          setStatus('failed')
        }
      } catch {
        setStatus('failed')
      }
    }

    verify()
  }, [navigate, searchParams])

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {status === 'checking' && (
          <>
            <div style={styles.icon}>⏳</div>
            <h2 style={styles.title}>Verifying Payment...</h2>
            <p style={styles.text}>Please wait</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div style={styles.icon}>✅</div>
            <h2 style={{ ...styles.title, color: '#22c55e' }}>Payment Successful!</h2>
            <p style={styles.text}>Redirecting to dashboard...</p>
          </>
        )}
        {status === 'failed' && (
          <>
            <div style={styles.icon}>❌</div>
            <h2 style={{ ...styles.title, color: '#ef4444' }}>Payment Failed</h2>
            <p style={styles.text}>Please try again</p>

            <p><a href="mailto:support@aitrademinds.in">support@aitrademinds.in</a></p>
            <button style={styles.btn} onClick={() => navigate('/upgrade')}>
              Try Again
            </button>
          </>
        )}
      </div>
    </div>
  )
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    background: '#0a0e1a', minHeight: '100vh',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  card: {
    background: '#111827', border: '1px solid #1f2937',
    borderRadius: 12, padding: 40, textAlign: 'center', width: 320,
  },
  icon: { fontSize: 48, marginBottom: 16 },
  title: { color: '#fff', fontSize: 22, margin: '0 0 8px 0' },
  text: { color: '#6b7280', fontSize: 14 },
  btn: {
    background: '#00d4ff', color: '#000', border: 'none',
    padding: '12px 32px', borderRadius: 8, fontWeight: 700,
    cursor: 'pointer', marginTop: 16,
  },
}